import * as FIELD_NAME from 'constant/form-item-names'
import React from 'react'
import { Form, Checkbox } from 'antd'

const WebpageCheckbox = () => {
  return (
    <Form.Item noStyle>
      <Form.Item
        name={FIELD_NAME.WEBPAGE_CHECKBOX}
        valuePropName='checked'
      >
        <Checkbox>Webpage</Checkbox>
      </Form.Item>
    </Form.Item>
  )
}

export default WebpageCheckbox
